/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Import_Status_Loading_InfoInputs */



/**
* | output |
* | --- |
* | "Loading project info... please wait a moment." |
*
* @param {Iconik_Import_Status_Loading_InfoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_import_status_loading_info = /** @type {((inputs?: Iconik_Import_Status_Loading_InfoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Import_Status_Loading_InfoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chargement des informations du projet... veuillez patienter.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projektinformationen werden geladen... Bitte warten Sie einen Moment.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Caricamento informazioni sul progetto... attendere un attimo.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Загрузка информации о проекте... пожалуйста, подождите немного.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cargando información del proyecto... por favor espere un momento.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在加载项目信息……请稍候。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクト情報を読み込んでいます...しばらくお待ちください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोजेक्ट की जानकारी लोड हो रही है... कृपया थोड़ी देर प्रतीक्षा करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Carregando informações do projeto... aguarde um momento.")
	return /** @type {LocalizedString} */ ("Loading project info... please wait a moment.")
});